let storage = window.localStorage, status = null;
((typeof (storage.language) === 'undefined') || (storage.language === 'zh-CN')) ? status = true : status = false;

const Info = [
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/zyh.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/zyh.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '曾烨豪',
        education: '本科',
        university: '汉语国际教育/昆明理工大学',
        credential: ['普通话等级证书'],
        experience: '3',
        feature: '热情洋溢,多才多艺,课堂互动多'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/hcj.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/hcj.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '黄楚君',
        education: '本科',
        university: '汉语国际教育/黑龙江外国语学院',
        credential: ['普通话二甲证书', '国际汉语教师资格证'],
        experience: '3',
        feature: '严谨认真,善于引导,亲和力强'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/ml.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/ml.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '慕琳',
        education: '本科',
        university: '平顶山学院',
        credential: ['普通话一乙证书', '初中语文教师资格证', '国际汉语教师资格证'],
        experience: '3',
        feature: '活泼生动,善于引导'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/ys.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/ys.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '余珊',
        education: '本科',
        university: '河南师范大学',
        credential: ['普通话等级证书'],
        experience: '4',
        feature: '亲和力强,耐心温和'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/zkx.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/zkx.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '张可馨',
        education: '本科',
        university: '汉语国际教育/大连工业大学',
        credential: ['普通话等级证书', '国际汉语教师资格证'],
        experience: '3',
        feature: '耐心温和,积极鼓励,认真严谨'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/litian.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/litian.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '李恬',
        education: '本科',
        university: '闽南师范大学',
        credential: ['普通话一乙证书', '小学教师资格证'],
        experience: '3',
        feature: '善于引导,活泼生动'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/tqx.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/tqx.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '田清秀',
        education: '本科',
        university: '四川轻化工大学',
        credential: ['普通话等级证书'],
        experience: '4',
        feature: '耐心温和,亲和力强,声音甜美'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/dq.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/dq.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '丁琪',
        education: '本科',
        university: '汉语国际教育/中南民族大学',
        credential: ['普通话等级证书'],
        experience: '3',
        feature: '声音甜美,适合初学者,亲和力强'
    },



    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/zmm.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/zmm.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '张苗苗',
        education: '本科',
        university: '汉语国际教育/天津科技大学',
        credential: ['普通话等级证书(二级甲等)'],
        experience: '3',
        feature: '风趣幽默,热情洋溢,积极鼓励',
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/wxy.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/wxy.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '王心远',
        education: '硕士',
        university: '中国语言文学/长春理工大学',
        credential: ['普通话等级证书(一级乙等)', '国际汉语教师资格证', '教师资格证'],
        experience: '6',
        feature: '循循善诱,耐心温和,亲和力强'
    }, {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/cyh.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/cyh.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '曹玉环',
        education: '硕士',
        university: '汉语国际教育/沈阳师范大学',
        credential: ['普通话等级证书'],
        experience: '3',
        feature: '善于引导,严谨认真'
    }, {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/cms.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/cms.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '陈明诗',
        education: '硕士',
        university: '汉语国际教育/中国石油大学',
        credential: ['普通话等级证书(二级甲等)', '高中语文教师资格证'],
        experience: '2',
        feature: '善于引导,课堂互动多'
    }
    , {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/wgq.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/wgq.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '汪恭勤',
        education: '硕士',
        university: '语言学及应用语言学/温州大学',
        credential: ['普通话等级证书', '高级中学教师资格证(语文)'],
        experience: '3',
        feature: '声音甜美,积极鼓励'
    }
    , {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/sxr.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/sxr.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '孙欣汝',
        education: '硕士',
        university: '汉语国际教育/武汉大学',
        credential: ['普通话二甲', '中小学教师资格证'],
        experience: '3',
        feature: '活泼生动,善于引导'
    }
    , {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/xh.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/xh.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',

        name: '徐晖',
        education: '本科',
        university: '浙江外国语学院',
        credential: ['普通话等级证书',],
        experience: '4',
        feature: '课堂互动多,耐心温和'
    }
    , {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/cxy.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/cxy.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',

        name: '崔雪艳',
        education: '本科',
        university: '汉语国际教育/浙江传媒学院',
        credential: ['普通话等级证书(二级甲等)', '教师资格证'],
        experience: '3',
        feature: '热情洋溢,认真严谨'
    }
    , {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/lhj.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/lhj.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',

        name: '李海婧',
        education: '硕士',
        university: '汉语国际教育/西安外国语大学',
        credential: ['普通话等级证书(一级乙等)', '小学语文教师资格证'],
        experience: '8',
        feature: '积极鼓励,耐心温和'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/ljh.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/ljh.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',

        name: '刘金环',
        education: '硕士',
        university: '大连外国语大学',
        credential: ['普通话等级证书', '教师资格证'],
        experience: '3',
        feature: '亲和力强,积极鼓励'
    },





    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/wujuan.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/wujuan.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '吴娟',
        education: '硕士',
        university: '汉语国际教育/北京语言大学',
        credential: ['普通话等级证书', '教师资格证', '国际汉语教师资格证'],
        experience: '5',
        feature: '轻松活泼,超强亲和力'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/wx.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/wx.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '王璇',
        education: '本科',
        university: '对外汉语/大连外国语大学',
        credential: ['普通话等级证书', '教师资格证', '国际汉语教师资格证'],
        experience: '3',
        feature: '耐心,活泼,善于启发'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/liuyan.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/liuyan.png',
        name: '刘艳',
        education: '硕士',
        university: '汉语国际教育/西北大学',
        credential: ['普通话等级证书', '教师资格证'],
        experience: '7',
        feature: '循循善诱,注重启发'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/zj.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/zj.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '张晶',
        education: '本科',
        university: '对外汉语/北京理工大学',
        credential: ['普通话等级证书', '教师资格证'],
        experience: '15',
        feature: '经验丰富,热情尽责'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/ly.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/ly.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '丽雅',
        education: '硕士',
        university: '汉语国际教育/新疆大学',
        credential: ['普通话等级证书', '国际汉语教师资格证'],
        experience: '3',
        feature: '教学生动,很耐心'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/zed.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/zed.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/man.png',
        name: '张尔东',
        education: '本科',
        university: '汉语言文学/景德镇学院',
        credential: ['语文教师资格证'],
        experience: '4',
        feature: '知识丰富,幽默风趣'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/lzh.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/lzh.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/man.png',
        name: '路振华',
        education: '硕士',
        university: '汉语国际教育/北京师范大学',
        credential: ['普通话等级证书', '国际汉语教师资格证'],
        experience: '3',
        feature: '热爱教学,严谨认真'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/gx.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/gx.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: '高溪',
        education: '硕士',
        university: '汉语国际教育/山东大学',
        credential: ['普通话等级证书', '国际汉语教师资格证'],
        experience: '3',
        feature: '热情活泼,细致周到'
    }
]
const InfoEnglish = [
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/zmm.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/zmm.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Miaomiao zhang',
        education: 'graduate',
        university: 'Tianjin University of Science and Technology',
        credential: ['Certificate of Mandarin Proficiency Test，high grade'],
        experience: '3',
        feature: 'humorous'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/wxy.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/wxy.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Xinyuan Wang',
        education: 'master',
        university: 'Changchun University of Science and Technology',
        credential: ['Chinese Teacher Certificate issued by Chinese Ministry of Education', 'CTCSOL issued by Confucius Institute Headquarters'],
        experience: '6',
        feature: 'inspiration,Patient,Approachable'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/cyh.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/cyh.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Yuhuan Cao',
        education: 'master',
        university: 'Shenyang Normal University',
        credential: ['Certificate of Mandarin Proficiency Test，high grade'],
        experience: '4',
        feature: 'Good at guiding,Conscientious'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/cms.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/cms.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Mingshi Chen',
        education: 'master',
        university: 'China University Of Petroleum',
        credential: ['Chinese Teacher Certificate issued by Chinese Ministry of Education', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '2',
        feature: 'Good at Interacting,Good at guiding'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/wgq.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/wgq.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Gongqin Wang',
        education: 'master',
        university: 'Wenzhou University',
        credential: ['Chinese Teacher Certificate issued by Chinese Ministry of Education', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '6',
        feature: 'Sweet voice,Good at encouraging'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/sxr.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/sxr.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Xinru Sun',
        education: 'master',
        university: 'han University',
        credential: ['Chinese Teacher Certificate issued by Chinese Ministry of Education', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '3',
        feature: 'lively,Good at guiding'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/xh.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/xh.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Hui Xu',
        education: 'graduate',
        university: 'Zhejiang International Studies University',
        credential: ['Certificate of Mandarin Proficiency Test，high grade'],
        experience: '4',
        feature: 'Good at Interacting,Patient'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/cxy.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/cxy.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Xueyan Cui',
        education: 'graduate',
        university: 'Communication University of Zhejiang',
        credential: ['Certificate of Mandarin Proficiency Test，high grade'],
        experience: '3',
        feature: 'Enthusiastic,Conscientious'
    },

    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/lhj.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/lhj.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Haijing Li ',
        education: 'master',
        university: 'Xi`an International Studies University',
        credential: ['Chinese Teacher Certificate issued by Chinese Ministry of Education', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '8',
        feature: 'Good at encouraging,Patient'
    },
    {

        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/ljh.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/ljh.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',

        name: 'Jinhuan Liu',
        education: 'master',
        university: 'Dalian international studies university',
        credential: ['Chinese Teacher Certificate issued by Chinese Ministry of Education', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '3',
        feature: 'Good at encouraging,Patient'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/zyh.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/zyh.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Ye hao Zeng',
        education: 'graduate',
        university: 'Kunming University of Science and technology Oxbridge College',
        credential: ['Certificate of Mandarin Proficiency Test，high grade'],
        experience: '3',
        feature: 'Enthusiastic,Versatile,Good at Interacting'
    },

    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/zkx.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/zkx.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Kexin zhang',
        education: 'graduate',
        university: 'Dalian Polytechnic University',
        credential: ['CTCSOL issued by Confucius Institute Headquarters', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '3',
        feature: 'Conscientious,Patient,Good at encouraging'
    },

    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/dq.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/dq.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Qi Ding',
        education: 'graduate',
        university: 'South-Central Minzu University',
        credential: ['Chinese Teacher Certificate issued by Chinese Ministry of Education', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '3',
        feature: 'Sweet voice,Patient,Approachable'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/litian.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/litian.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Tian Li',
        education: 'graduate',
        university: 'Minnan Normal University',
        credential: ['Chinese Teacher Certificate issued by Chinese Ministry of Education', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '3',
        feature: 'Good at guiding,Patient,lively'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/tqx.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/tqx.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Qingxiu Tian',
        education: 'graduate',
        university: 'Sichuan University of Science & Engineering',
        credential: ['Certificate of Mandarin Proficiency Test，high grade'],
        experience: '4',
        feature: 'Patient,Approachable,Sweet voice'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/hcj.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/hcj.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Chujun Huang',
        education: 'graduate',
        university: 'Helongjiang International University',
        credential: ['CTCSOL issued by Confucius Institute Headquarters', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '3',
        feature: 'Conscientious,Good at guiding,Approachable'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/ys.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/ys.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Shan Yu',
        education: 'graduate',
        university: 'Henan Normal University',
        credential: ['Certificate of Mandarin Proficiency Test，high grade'],
        experience: '4',
        feature: 'Patient,Patient,Approachable'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/ml.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/ml.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Lin Mu',
        education: 'graduate',
        university: 'Pingdingshan University',
        credential: ['CTCSOL issued by Confucius Institute Headquarters', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '3',
        feature: 'Lively,Good at guiding'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/wujuan.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/wujuan.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Juan Wu',
        education: 'master',
        university: 'Beijing Language and Culture University, majored in Teaching Chinese to Speakers of Other Languages',
        credential: ['Chinese Teacher Certificate issued by Chinese Ministry of Education', 'CTCSOL issued by Confucius Institute Headquarters', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '5',
        feature: 'lively, easy-going, dedicated'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/wx.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/wx.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Xuan Wang',
        education: 'graduate',
        university: 'Beijing Language and Culture University, majored in Teaching Chinese to Speakers of Other Languages',
        credential: ['Chinese Teacher Certificate issued by Chinese Ministry of Education', 'CTCSOL issued by Confucius Institute Headquarters', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '3',
        feature: 'rigorous, lively, heuristic teaching'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/liuyan.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/liuyan.png',
        name: 'Yan Liu',
        education: 'master',
        university: 'Northwest University, majored in Teaching Chinese to Speakers of Other Languages',
        credential: ['Chinese Teacher Certificate issued by Chinese Ministry of Education', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '7',
        feature: 'being amiable，good at inspiring'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/zj.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/zj.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Jing Zhang',
        education: 'graduate',
        university: 'Beijing Institute of Technology, majored in Teaching Chinese to Speakers of Other Languages',
        credential: ['Chinese Teacher Certificate issued by Chinese Ministry of Education', 'CTCSOL issued by Confucius Institute Headquarters', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '15',
        feature: 'very experienced，passionate'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/ly.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/ly.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Ya Li',
        education: 'master',
        university: 'Xinjiang University, majored in Teaching Chinese to Speakers of Other Languages',
        credential: ['CTCSOL issued by Confucius Institute Headquarters', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '3',
        feature: ' lively and patient'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/zed.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/zed.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/man.png',
        name: 'Dongdong Zhang ',
        education: 'graduate',
        university: ' Jingdezhen University, majored in Chinese Language and Literature',
        credential: ['Chinese Teacher Certificate issued by Chinese Ministry of Education'],
        experience: '4',
        feature: 'very learned，humorous'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/lzh.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/lzh.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/man.png',
        name: 'Zhenhua Lu',
        education: 'master',
        university: 'Beijing Normal University, majored in Teaching Chinese to Speakers of Other Languages',
        credential: ['CTCSOL issued by Confucius Institute Headquarters', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '3',
        feature: 'love teaching，compassionate'
    },
    {
        img: '//cdn.ihatoo.com/hatu-official/teacher/yuan/gx.png',
        imgs: '//cdn.ihatoo.com/hatu-official/teacher/fang/gx.png',
        xing: '//cdn.ihatoo.com/hatu-official/teacher/woman.png',
        name: 'Xi Gao',
        education: 'master',
        university: 'Shandong University, majored in Teaching Chinese to Speakers of Other Languages',
        credential: ['CTCSOL issued by Confucius Institute Headquarters', 'Certificate of Mandarin Proficiency Test，high grade'],
        experience: '3',
        feature: 'lively, patient, thoughtful'
    }

]

export default status ? Info : InfoEnglish;
